<template>
  <el-dialog :visible.sync="innerVisible" :title="$t('SeaExport.BookingAudit')" width="620px" custom-class="cargo-form-dialog" :close-on-click-modal="false" @close="handleClose">
    <el-form ref="form" label-width="100px" label-position="left" class="cargo-form">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label-width="0" class="auto-width">
            <el-radio-group v-model="radioType" no="1">
              <el-radio :label="1">{{ $t('SeaExport.UseThisNo') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="isDifferentJobOrBusinessFieldValues" :gutter="10">
        <el-col :span="24">
          <el-form-item label-width="0" class="auto-width">
            <i class="el-icon-warning" style="color: #e6a23c;margin-left: 5px" />
            <span style="font-size: 12px;">{{ $t('Message.DifferentJobOrBusinessFieldValues') }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.OperationCompany') }}：</span>
            <cargo-office-select
              no="2"
              :clearable="false"
              :have-hq="false"
              :disabled="isTrustFrom"
              :office-id="Number(job.opOffice)"
              tag-name="code"
              tooltip
              @change="p=>{job.opOffice=p.value;officeChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.Operation')+'：'">
            <cargo-user-select
              no="3"
              :placeholder="differentForm.op ? $t('CargoMsg.Cargo_keyWordsTip') : $t('Message.PreserveOriginalValue') + $t('SeaExport.Operation')"
              :method-params="{officeId:job.opOffice,category:'role',shape:'op'}"
              :default-value="job.op||''"
              @change="p=>{job.op=p.value;differentForm.op=true;opChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item>
            <span slot="label" :class="isBatchUpdate ? '' : 'blue'">{{ $t('SeaExport.OperationDepartment') }}：</span>
            <cargo-department-select
              no="4"
              :placeholder="differentForm.opDepartment ? $t('CargoMsg.Cargo_keyWordsTip') : $t('Message.PreserveOriginalValue') + $t('SeaExport.OperationDepartment')"
              :office-id="Number(job.opOffice) || $store.getters.currentOfficeId"
              :department-id="Number(job.opDepartment)"
              @change="p=>{job.opDepartment=p.value;differentForm.opDepartment=true;}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.CustomerService')+'：'">
            <cargo-user-select
              ref="csr"
              no="5"
              :placeholder="differentForm.csr ? $t('CargoMsg.Cargo_keyWordsTip') : $t('Message.PreserveOriginalValue') + $t('SeaExport.CustomerService')"
              :method-params="{officeId:(isTrustFrom || job.salesOffice===1)?job.opOffice:job.salesOffice,category:'role',shape:'csr'}"
              :default-value="job.csr||''"
              @change="p=>{job.csr=p.value;differentForm.csr=true;csrChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.Documents')+'：'">
            <cargo-user-select
              ref="dc"
              no="6"
              :placeholder="differentForm.dc ? $t('CargoMsg.Cargo_keyWordsTip') : $t('Message.PreserveOriginalValue') + $t('SeaExport.Documents')"
              :method-params="{officeId:job.opOffice,category:'role',shape:'doc'}"
              :default-value="job.dc||''"
              @change="p=>{job.dc=p.value;differentForm.dc=true;dcChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole1')+'：'">
            <cargo-user-select
              ref="userDefinedRoleId1"
              no="24"
              :placeholder="differentForm.userDefinedRoleId1 ? $t('CargoMsg.Cargo_keyWordsTip') : $t('Message.PreserveOriginalValue') + $t('CargoMsg.Cargo_userDefinedRole1')"
              :method-params="{officeId:job.opOffice,category:'role',shape:'userDefinedRole1'}"
              :default-value="job.userDefinedRoleId1||''"
              @change="p=>{job.userDefinedRoleId1=p.value;differentForm.userDefinedRoleId1=true;userDefinedRole1ChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole2')+'：'">
            <cargo-user-select
              ref="userDefinedRoleId2"
              no="25"
              :placeholder="differentForm.userDefinedRoleId2 ? $t('CargoMsg.Cargo_keyWordsTip') : $t('Message.PreserveOriginalValue') + $t('CargoMsg.Cargo_userDefinedRole2')"
              :method-params="{officeId:job.opOffice,category:'role',shape:'userDefinedRole2'}"
              :default-value="job.userDefinedRoleId2||''"
              @change="p=>{job.userDefinedRoleId2=p.value;differentForm.userDefinedRoleId2=true;userDefinedRole2ChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.ContractRateProperty')+'：'">
            <el-select
              v-model="job.bookingTerm"
              no="7"
              :placeholder="differentForm.bookingTerm ? $t('SeaExport.PleaseSelect') : $t('Message.PreserveOriginalValue') + $t('SeaExport.ContractRateProperty')"
              :clearable="false"
              size="mini"
              @change="p=>{differentForm.bookingTerm=true;bookingTermChangeHandler(p)}"
            >
              <el-option
                v-for="(item,index) in bookingTerms"
                :key="index"
                :label="isZh ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$t('SeaExport.BookingAgent')+'：'" class="red-input">
            <cargo-advance-select
              no="8"
              :placeholder="differentForm.bookingAgent ? $t('CargoMsg.Cargo_keyWordsTip') : $t('Message.PreserveOriginalValue') + $t('SeaExport.BookingAgent')"
              :select-type="selectTypeNames.basic_data_Company"
              filterable
              :method-params="{bookingAgent:true,companyLob:'seaExport',active:true}"
              :default-value="job.bookingAgent||''"
              @parentCallBack="p=>{job.bookingAgent=p.value;differentForm.bookingAgent=true;}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item>
            <b slot="label">{{ $t('SeaExport.ShippingCompany') + '：' }}</b>
            <cargo-advance-select
              no="9"
              :disabled="!isSameVesselAndFlight"
              filterable
              :select-type="TYPE_NAMES.basic_data_Company"
              :method-params="{seaCmp:true,companyLob:'seaExport',active:true}"
              :default-value="isSameVesselAndFlight ? (job.carrierId || '') : ''"
              :placeholder="differentForm.carrierId ? ' ' : $t('Message.PreserveOriginalValue') + $t('SeaExport.ShippingCompany')"
              @parentCallBack="p=>{job.carrierId=p.value;differentForm.carrierId=true;}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item>
            <b slot="label">{{ $t('SeaExport.Vessel') + '：' }}</b>
            <cargo-advance-select
              no="10"
              :disabled="!isSameVesselAndFlight"
              :select-type="TYPE_NAMES.static_data_Vessel"
              :cache="false"
              filterable
              :allow-create="allowEditingVessel"
              :default-value="isSameVesselAndFlight ? job.vessel : ''"
              :static-options="vesselList"
              :placeholder="differentForm.vessel ? ' ' : $t('Message.PreserveOriginalValue') + $t('SeaExport.Vessel')"
              @parentCallBack="p=>{differentForm.vessel=true;onVesselSelectionChange(p)}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <b slot="label">{{ $t('SeaExport.Voyage') + '：' }}</b>
            <cargo-advance-select
              ref="voyageFlight"
              no="11"
              :disabled="!isSameVesselAndFlight"
              :cache="false"
              filterable
              clearable
              :allow-create="allowEditingVoyageFlight"
              :default-value="isSameVesselAndFlight ? job.voyageFlight : ''"
              tag-name="voyageNo"
              tag-value="voyageNo"
              :static-options="voyages"
              :placeholder="differentForm.voyageFlight ? ' ' : $t('Message.PreserveOriginalValue') + $t('SeaExport.Voyage')"
              @focus="txtVoyageFocusInHandler"
              @parentCallBack="p=>{job.voyageFlight=p.value;differentForm.voyageFlight=true;}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="IMO">
            <el-input v-if="isSameVesselAndFlight" v-model="job.vesselIMO" no="12" :placeholder="differentForm.vesselIMO ? '' : $t('Message.PreserveOriginalValue') + 'IMO'" @change="p=>{differentForm.vesselIMO=true;}" />
            <el-input v-else v-model="undefined" no="13" :disabled="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item>
            <b slot="label">{{ $t('SeaExport.ServiceCode') + '：' }}</b>
            <el-input v-if="isSameVesselAndFlight" v-model="job.vesselLineCode" no="14" :placeholder="differentForm.vesselLineCode ? '' : $t('Message.PreserveOriginalValue') + $t('SeaExport.ServiceCode')" @change="p=>{differentForm.vesselLineCode=true;}" />
            <el-input v-else v-model="undefined" no="15" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col v-show="isDisplayOP" :span="12">
          <el-form-item :label="$t('SeaExport.ShippingCompanyContractNo')+'：'">
            <el-input v-model="job.scNo" no="16" />
            <el-checkbox v-model="AddApproximateSymbolToItemColumn" no="26">{{ $t('SeaExport.AddApproximateSymbolToItemColumn') }}</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="N/A：">
            <el-input v-model="job.na" no="17" :placeholder="differentForm.na ? '' : $t('Message.PreserveOriginalValue') + 'N/A'" @change="p=>{differentForm.na=true;}" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="N/A CODE：">
            <el-input v-model="job.naCode" no="18" :placeholder="differentForm.naCode ? '' : $t('Message.PreserveOriginalValue') + 'N/A CODE'" @change="p=>{differentForm.naCode=true;}" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-show="isDisplayOP" :gutter="10">
        <el-col :span="12">
          <el-form-item label="LINE CODE：">
            <el-input v-model="job.laneCode" no="19" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="CODE：">
            <el-input v-model="job.subContractNo" no="20" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$t('SeaExport.Remarks')+'：'">
            <el-input v-model="bookingAuditRemark" no="21" type="textarea" :rows="2" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-checkbox v-model="overwriteOriginalRemarkFlag" no="24" style="margin-left: 100px;">{{ $t('SeaExport.OverwriteOriginalRemark') }}</el-checkbox>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" style="padding:10px;">
      <el-button no="22" type="primary" @click="handleSubmit">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button no="23" @click="handleClose">{{ $t('SeaExport.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import CargoForm from '@/components/Cargo/Common/CargoForm'
import { BOOKING_TERMS } from '@/class/cargo/model/parameters/SeaExportConstants'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { Company } from '@/class/model/mdm/Company'
import { Voyage } from '@/class/model/mdm/Voyage'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import { cacheName, cache } from '@/utils/cacheManager'
import { loadSpecificBasicInfo } from '@/api/cache'
import { getSeaExportJobByUuid } from '@/api/seaExport/seaExportJob'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getUserInfo } from '@/utils/auth'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'OpVerifyFrameDialog',
  components: { cargoDepartmentSelect, cargoOfficeSelect, cargoUserSelect, cargoCompanySelect, cargoAdvanceSelect, CargoForm },
  props: {
    visible: { type: Boolean, default: () => false },
    batchPassAudit: { type: Boolean, default: () => false },
    jobModel: { type: Object, default: () => ({}) },
    submitCallBack: { type: Function, default: () => (null) },
    jobList: { type: Array, default: () => ([]) }
  },
  data() {
    return {
      TYPE_NAMES,
      vesselList: [],
      voyages: [],
      job: {
        opOffice: 0,
        op: 0,
        opDepartment: 0,
        csr: 0,
        dc: 0,
        bookingTerm: 'OS',
        bookingAgent: 0,
        subContractNo: '',
        carrierId: 0,
        vessel: '',
        voyageFlight: '',
        vesselIMO: '',
        vesselLineCode: '',
        remarks: '',
        laneCode: '',
        na: '',
        scNo: '',
        naCode: '',
        userDefinedRoleId1: '',
        userDefinedRoleId2: ''
      },
      selectTypeNames: TYPE_NAMES,
      isTrustFrom: false,
      innerVisible: false,
      isDisplayOP: true,
      isSameVesselAndFlight: true,
      popperClass: '#E9650E',
      radioType: 1, // 默认选中项
      pretrialReviewThroughRole: false, // 预审审核权限
      pretrialReviewConfig: false, // 是否开启预审审核配置
      editVesselVoyageMode: 2, // 录入船名的模式(1允许直接录入,2自有约价的情况下不允许录入,3任何情况下都不允许录入)
      editVoyageMode: 1, // 1.直接录入 2 .选择
      bookingTerms: BOOKING_TERMS, // 约价性质
      isAddUserDefinedRoles: false, // 是否显示自定义岗位
      isDifferentJobOrBusinessFieldValues: false,
      differentForm: {
        opOffice: true,
        op: true,
        opDepartment: true,
        csr: true,
        dc: true,
        userDefinedRoleId1: true,
        userDefinedRoleId2: true,
        bookingTerm: true,
        bookingAgent: true,
        carrierId: true,
        vessel: true,
        voyageFlight: true,
        vesselIMO: true,
        vesselLineCode: true,
        na: true,
        naCode: true
      },
      currentUserInfo: {},
      bookingAuditRemark: '',
      overwriteOriginalRemarkFlag: false,
      AddApproximateSymbolToItemColumn: false // 添加约号到品名栏
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    vesselEnabled() {
      return this.editVesselVoyageMode === 1 || (this.editVesselVoyageMode === 2 && this.job.bookingTerm !== 'OS')
    },
    allowEditingVessel() {
      return this.editVesselVoyageMode === 1 || (this.editVesselVoyageMode === 2 && this.job.bookingTerm !== 'OS')
    },
    allowEditingVoyageFlight() {
      return this.editVoyageMode === 1
    },
    isBatchUpdate() { // 是否批量修改
      return this.jobList && this.jobList.length > 1
    }
  },
  watch: {
    visible: {
      immediate: true,
      async handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          await this.init()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.pretrialReviewThroughRole = this.$checkPermission(['button_fmVerify_reviewThrough'])
    this.pretrialReviewConfig = parseInt(cache.config.get('PretrialReview')) === 1
    this.editVesselVoyageMode = parseInt(cache.config.get('EditVesselVoyageMode'))
    this.editVoyageMode = parseInt(cache.config.get('EditVoyageMode'))
    loadSpecificBasicInfo('Vessel').then(res => {
      this.vesselList = res.data
      const data = this.vesselList.find(p => p.englishName === this.jobModel.vessel)
      if (data) {
        this.getVoyageByVessel(data)
      }
    })
    this.isAddUserDefinedRoles = Number(cache.config.get('IsAddUserDefinedRoles')) === 1
  },
  methods: {
    async init() {
      this.currentUserInfo = getUserInfo()
      const flag = LocalStorageUtilsNew.getConfiguration(`local_sea_export_booking_audit_overwrite_original_remark_flag_${this.currentUserInfo.tenantId}_${this.currentUserInfo.userId}`)
      const flagItem = LocalStorageUtilsNew.getConfiguration(`local_sea_export_booking_audit_approximate_symbol_to_item_column_flag`)
      this.overwriteOriginalRemarkFlag = flag === '' ? true : flag
      this.AddApproximateSymbolToItemColumn = flagItem === '' ? true : flagItem
      const dbJob = await getSeaExportJobByUuid(this.jobModel.uuid).then((res) =>
        res.data ? res.data : null
      )
      if (dbJob) Object.assign(this.job, dbJob)
      this.job.opOffice = this.job.opOffice || 1
      this.job.bookingTerm = this.job.bookingTerm || 'OS'
      this.isDisplayOP = this.job.bookingTerm === BookingTerm.OS_BOOKING_TYPE.code
      this.isTrustFrom = await this.checkTrustFrom()

      const deps = getCacheListByKey(basicCacheKeys.basic_data_Department)
      let officeId = ''
      if (this.job.opDepartment && this.job.opDepartment > 0 && deps && deps.length > 0) {
        let officeUuid = ''
        const dep = deps.find(p => p.departmentId === this.job.opDepartment)
        if (dep) officeUuid = dep.officeUuid
        if (officeUuid) {
          const officeList = getCacheListByKey(basicCacheKeys.basic_data_Office)
          const office = officeList.find(p => p.uuid === officeUuid)
          if (office) officeId = office.officeId
        }
      }
      if ((officeId && officeId !== this.job.opOffice)) {
        this.job.opDepartment = 0
      }

      this.checkSameVesselAndFlight()
      this.isDifferentJobOrBusinessFieldValues = JobUtils.verifyCheckJobFieldDifferent(this.job, this.jobList, this.differentForm, SystemConstants.SE.code)

      // 处理审核备注显示 备注内容单挑带出信息，多条则不显示
      if (!this.batchPassAudit) {
        this.bookingAuditRemark = this.job.remarks
      }
    },
    // 非委托单｛ job.salesOffice=当前分公司
    // and (job.trustFromJob is null or job.trustFromJob = '') and 委托单位不是内部公司)｝
    // 则客服跟销售公司，允许修改操作公司，否则委托单客服跟操作公司，不允许修改操作公司
    async checkTrustFrom() {
      const company = await Company.getCompanyById(this.job.customerId)
      const currentOfficeId = this.$store.getters.currentOfficeId
      if (this.job.salesChannel === 'B2B') { return false }
      if ((this.job.salesOffice && parseInt(this.job.salesOffice) === currentOfficeId && !this.job.trustFromJob && company && company.linkedBranchId === 0) || (this.job.salesOffice === 1)) {
        return false // 非委托单
      }
      return true
    },
    // 切换分公司
    officeChangeHandler() {
      if (!this.job.opOffice || this.job.opOffice <= 0) {
        this.job.opOffice = this.$store.getters.currentOfficeId
      }
      // var office:Office = mainOffice.selectedItem as Office;
      // if(null == office) {
      //   office = Session.getInstance().currentOffice;
      // }
      // ddlDepartment.officeId = office.officeId;
      // op.queryUser("role","op",null,office);
      // dc.queryUser("role","doc",null,office);
      // if(isTrustFrom || job.salesOffice == 1)
      // {
      //   csr.queryUser("role","csr",null,office);
      // }
    },
    // 选择操作时，获取操作分公司
    opChangeHandler(user) {
      if (user.defaultDepId > 0) {
        this.job.opDepartment = user.defaultDepId
      } else {
        if (this.job.opOffice > 0) {
          new User(user).getUserDefaultDepartmentByOffice('role', 'op', this.job.opOffice).then(dep => {
            this.job.opDepartment = dep ? dep.departmentId : 0
          })
        } else {
          new User(user).getDefaultDepartment('role', 'op', this.job.opOffice).then(dep => {
            this.job.opDepartment = dep ? dep.departmentId : 0
          })
        }
      }
    },
    // 客服改变
    async csrChangeHandler(data) {
      this.job.csr = data.value
      this.job.csrDepartment = 0
      this.job.csrOffice = 0
      if (data.value) {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'csr')
        if (dep) {
          this.job.csrDepartment = dep.departmentId
          const office = await Office.getOfficeByUuid(dep.officeUuid)
          this.job.csrOffice = office ? office.officeId : 0
        }
      }
    },
    // 单证改变
    async dcChangeHandler(data) {
      this.job.dc = data.value
      this.job.dcDepartment = 0
      this.job.dcOffice = 0
      if (data.value) {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'doc')
        this.job.dcDepartment = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        this.job.dcOffice = office ? office.officeId : 0
      } else {
        this.job.dc = 0
        this.job.dcDepartment = 0
        this.job.dcOffice = 0
      }
    },
    // 约价性质
    bookingTermChangeHandler() {
      this.isDisplayOP = this.job.bookingTerm === BookingTerm.OS_BOOKING_TYPE.code
    },
    /**
     * vessel change
     */
    onVesselSelectionChange(data) {
      this.job.vessel = data.value
      if (data.value && data.uuid) {
        this.job.vesselIMO = data.imoCode
      } else {
        this.job.vesselIMO = ''
      }
      this.getVoyageByVessel(data)
    },
    async getVoyageByVessel(data) {
      if (data.vesselId) {
        this.voyages = await Voyage.getVoyage(data.vesselId)
      } else {
        this.voyages = []
      }
    },
    txtVoyageFocusInHandler() {
      const judgmentOfVoyageNo = cache.config.get('JudgmentOfVoyageNo')
      if (judgmentOfVoyageNo !== '1') {
        return
      }
      let value = 'V.'
      if (this.job.voyageFlight) {
        value = this.job.voyageFlight
        this.job.voyageFlight = ''
      }
      this.$nextTick(() => {
        this.job.voyageFlight = value
        const elSelect = this.$refs.voyageFlight.$refs.cargoAdvanceSelect
        const innerInput = elSelect.$children[0].$refs.input
        innerInput.value = this.job.voyageFlight
      })
    },
    handleSubmit() {
      // if ((!this.job.op || this.job.op <= 0) && this.job.salesChannel === 'JJCARGO') {
      //   this.$message.warning(this.$t('SeaExport.OperationCannotBeEmpty'))
      //   return
      // }
      if (!this.job.opOffice || this.job.opOffice === 1 || this.job.opOffice <= 0) {
        this.$message.warning(this.$t('SeaExport.OperationCompanyCannotBeEmpty'))
        return
      }
      if (!this.isBatchUpdate) {
        if (!this.job.opDepartment || this.job.opDepartment <= 0) {
          this.$message.warning(this.$t('SeaExport.OperationDepartmentCannotBeEmpty'))
          return
        }
      }
      const form = {}
      form.opOffice = this.job.opOffice || 0
      form.op = this.job.op || 0
      if (this.job.opDepartment && this.job.opDepartment > 0) {
        form.opDepartment = this.job.opDepartment || 0
      }
      form.csr = this.job.csr || 0
      form.dc = this.job.dc || 0
      form.bookingTerm = this.job.bookingTerm
      form.bookingAgent = this.job.bookingAgent || 0
      form.userDefinedRoleOffice1 = this.job.userDefinedRoleOffice1 || 0
      form.userDefinedRoleId1 = this.job.userDefinedRoleId1 || 0
      if (this.job.userDefinedRoleDept1 && this.job.userDefinedRoleDept1 > 0) {
        form.userDefinedRoleDept1 = this.job.userDefinedRoleDept1 || 0
      }
      form.userDefinedRoleOffice2 = this.job.userDefinedRoleOffice2 || 0
      form.userDefinedRoleId2 = this.job.userDefinedRoleId2 || 0
      if (this.job.userDefinedRoleDept2 && this.job.userDefinedRoleDept2 > 0) {
        form.userDefinedRoleDept2 = this.job.userDefinedRoleDept2 || 0
      }
      if (this.isSameVesselAndFlight) {
        form.carrierId = this.job.carrierId || 0
        form.vessel = this.job.vessel
        form.voyageFlight = this.job.voyageFlight
        form.vesselIMO = this.job.vesselIMO
        form.vesselLineCode = this.job.vesselLineCode
      }
      form.ifUpdateShippingInfo = this.isSameVesselAndFlight
      form.remarks = this.job.remarks
      form.na = this.job.na
      form.naCode = this.job.naCode
      if (BookingTerm.OS_BOOKING_TYPE.code === this.job.bookingTerm) {
        form.laneCode = this.job.laneCode
        form.subContractNo = this.job.subContractNo
        form.scNo = this.job.scNo
        let englishName = ''
        if (this.job.subContractNo) {
          englishName += 'CODE:' + this.job.subContractNo + '\r'
        }
        if (this.job.na) {
          englishName += 'N/A:' + this.job.na + '\r'
        }
        if (this.job.naCode) {
          englishName += 'N/A CODE:' + this.job.naCode
        }
        form.cargoEnglishName = englishName
        // 原来有品名的话，则追加，放在后端处理
        // if (this.job.cargoChineseName.trim().length > 0) { form.cargoEnglishName += '\r' }
        // form.cargoEnglishName += englishName
      }
      if (!this.batchPassAudit) {
        // 对于JJCARGO传过来的业务，将操作人员的信息封装到charge.createdBy, 放在后端处理
        // if (this.job.salesChannel === 'JJCARGO') {
        //   for (const charge of this.job.charges) {
        //     if (charge.createdBy === 0) {
        //       charge.createdBy = this.job.op
        //     }
        //   }
        // }
      }
      form.overwriteOriginalRemarkFlag = this.overwriteOriginalRemarkFlag
      form.bookingAuditRemark = this.bookingAuditRemark
      form.differentForm = this.differentForm
      this.submitCallBack(form)
      this.handleClose()
      // 确认后保存上次的overwriteOriginalRemarkFlag到浏览器缓存中
      LocalStorageUtilsNew.setConfiguration(`local_sea_export_booking_audit_overwrite_original_remark_flag_${this.currentUserInfo.tenantId}_${this.currentUserInfo.userId}`, this.overwriteOriginalRemarkFlag)
      // 确认后保存上次的AddApproximateSymbolToItemColumn到浏览器缓存中
      LocalStorageUtilsNew.setConfiguration(`local_sea_export_booking_audit_approximate_symbol_to_item_column_flag`, this.AddApproximateSymbolToItemColumn)
    },
    checkSameVesselAndFlight() {
      const vessel = this.jobModel.vessel
      const voyageFlight = this.jobModel.voyageFlight
      for (const job of this.jobList) {
        if (vessel !== job.vessel || voyageFlight !== job.voyageFlight) {
          this.isSameVesselAndFlight = false
          return
        }
      }
    },
    handleClose() {
      this.innerVisible = false
    },
    // 自定义岗位1
    async userDefinedRole1ChangeHandler(data) {
      this.job.userDefinedRoleId1 = data.value
      this.job.userDefinedRoleDept1 = 0
      this.job.userDefinedRoleOffice1 = 0
      if (data.value) {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole1')
        this.job.userDefinedRoleDept1 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        this.job.userDefinedRoleOffice1 = office ? office.officeId : 0
      } else {
        this.job.userDefinedRoleId1 = 0
        this.job.userDefinedRoleDept1 = 0
        this.job.userDefinedRoleOffice1 = 0
      }
    },
    // 自定义岗位2
    async userDefinedRole2ChangeHandler(data) {
      this.job.userDefinedRoleId2 = data.value
      this.job.userDefinedRoleDept2 = 0
      this.job.userDefinedRoleOffice2 = 0
      if (data.value) {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole2')
        this.job.userDefinedRoleDept2 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        this.job.userDefinedRoleOffice2 = office ? office.officeId : 0
      } else {
        this.job.userDefinedRoleId2 = 0
        this.job.userDefinedRoleDept2 = 0
        this.job.userDefinedRoleOffice2 = 0
      }
    }
  }
}
</script>
<style lang="scss">
  .cargo-form-dialog{
    .el-dialog{
      &__header,&__body,&__footer{
        padding:10px 15px!important;
      }
      &__title{
        vertical-align: middle;
      }
      &__headerbtn{
        top:15px;
        right:15px;
      }
    }
  }
  .cargo-form{
    .el-form-item {
      &.red-input{
        .el-input__inner{
          color: #E9650E;
        }
      }
      &__content{
        width: auto!important;
      }
      &.label-none {
        .el-form-item__content{
          margin-left: 0;
        }
      }
    }
  }
</style>
